/**
 * Zone.js Flags Configuration
 * 
 * This file configures Zone.js performance optimizations by disabling
 * unnecessary patching that causes performance issues in Angular applications.
 * 
 * CRITICAL: requestAnimationFrame patch disabled
 * - Reason: Zone.js wrapping causes 199ms+ violations in DevTools
 * - Impact: Eliminates unnecessary RAF monitoring by Angular zone
 * - Note: Angular change detection still works; only RAF patch is disabled
 */

// Disable requestAnimationFrame patching (resolves continuous animation violations)
(window as any).__Zone_disable_requestAnimationFrame = true;

/**
 * OPTIONAL: Other optimizations can be added here:
 * 
 * (window as any).__Zone_disable_on_property = true;
 * // Disables patching of onProperty like onclick, onchange, etc.
 * // Use only if your app doesn't rely on Zone catching property events
 * 
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];
 * // Prevents Zone from patching specific high-frequency events
 * // These events can fire hundreds of times per second
 * 
 * (window as any).__Zone_enable_cross_context_check = true;
 * // For IE/Edge: bypasses zone.js patch for cross-context calls
 */
